import { Box, ButtonNew, Icon, SearchBar, Spacer, Tab, TextNew } from '@jfs/ui-new'
import React, { useEffect, useState } from 'react'
import { AepsButton } from '../../comps/AepsButton'
import { Container } from '../../comps/Container'
// Mock data and functions to simulate a dynamic component
const useLazyApiData = (apiFn) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const callApi = async () => {
    setLoading(true)
    setError(null)
    try {
      // Simulate an API call with
      const mockData = await new Promise((resolve) =>
        setTimeout(() => {
          // Mock data based on the section
          if (apiFn.name === 'fetchFavourites') {
            resolve([
              {
                id: '1',
                name: 'ICICI Bank FASTag',
                customerName: 'Prakash',
                vehicleNo: 'MH034589',
                lastLinked: 'O5 june 2025',
              },
              {
                id: '2',
                name: 'Airtel Postpaid',
                customerName: 'Rahul',
                mobileNo: '9876543210',
                lastLinked: '10 July 2025',
              },
            ])
          } else if (apiFn.name === 'fetchRecentPayments') {
            resolve([
              {
                id: '3',
                name: 'BSES Rajdhani',
                customerName: 'Anil',
                accountNo: '12345678',
                lastLinked: '22 May 2025',
              },
              { id: '4', name: 'JioFiber', customerName: 'Priya', accountNo: '87654321', lastLinked: '01 June 2025' },
            ])
          } else {
            resolve([])
          }
        }, 1000),
      )
      setData(mockData)
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }

  return [data, callApi, loading, error]
}

const mockFetchFavourites = () => {
  /* This function is just a placeholder to be used by the hook */
}
const mockFetchRecentPayments = () => {
  /* This function is just a placeholder to be used by the hook */
}

const staticData = [
  {
    initials: 'RJ',
    name: 'Riya Jain',
    phoneNumber: '9876543210',
  },
  {
    initials: 'RJ',
    name: 'Riya Jain',
    phoneNumber: '9876543210',
  },
  {
    initials: 'RJ',
    name: 'Riya Jain',
    phoneNumber: '9876543210',
  },
  {
    initials: 'RJ',
    name: 'Riya Jain',
    phoneNumber: '9876543210',
  },
  {
    initials: 'RJ',
    name: 'Riya Jain',
    phoneNumber: '9876543210',
  },
  {
    initials: 'RJ',
    name: 'Riya Jain',
    phoneNumber: '9876543210',
  },
  {
    initials: 'RJ',
    name: 'Riya Jain',
    phoneNumber: '9876543210',
  },
]

export const MobileRechargeScreen = () => {
  const [favourites, fetchFavourites, favouritesLoading] = useLazyApiData(mockFetchFavourites)
  const [recentPayments, fetchRecentPayments, paymentsLoading] = useLazyApiData(mockFetchRecentPayments)
  const [activeTab, setActiveTab] = useState('payBills')
  const [showInactivityDialog, setShowInactivityDialog] = useState(false)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [checked, setChecked] = useState(false)
  const handleInactivityDialogPress = () => {
    setShowInactivityDialog(false)
  }

  useEffect(() => {
    fetchFavourites()
    fetchRecentPayments()
  }, [])

  const searchList = (tnxId) => {
    // console.log(tnxId)
  }

  const handlePress = () => {
    setShowInactivityDialog(true)
  }

  const onPrimaryButtonPress = () => {
    setOpenConfirmDialog(true)
  }

  return (
    <Container showFooter={false} overflow="auto">
      <>
        <Box gap={30}>
          <Box flexDirection={'column'}>
            <Box backgroundColor="WHITE" flexDirection={'column'}>
              <SearchBar onChange={searchList} />
            </Box>
          </Box>
          <Box>
            <Box display={'flex'} flexDirection={'row'} justifyContent={'flex-end'}>
              <Box width={'50%'}>
                <AepsButton onPress={onPrimaryButtonPress} title={'Add Customer'} disabled={false} />
              </Box>
            </Box>
          </Box>
          {staticData.map((data, index) => (
            <Box
              key={index}
              display={'flex'}
              flexDirection={'row'}
              alignItems={'center'}
              gap={30}
              marginBottom={'16px'}
              //   style={{ marginBottom: '16px' }}
            >
              <Box
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                width={55}
                height={55}
                borderRadius={'50%'}
                backgroundColor={'BG_WHITE'}
                // backgroundColor={'rgb(248, 235, 215)'}
              >
                <TextNew fontSize={18}>{data.initials}</TextNew>
              </Box>
              <Box gap={8}>
                <Box>
                  <TextNew fontSize={18}>{data.name}</TextNew>
                </Box>
                <Box>{data.phoneNumber}</Box>
              </Box>
            </Box>
          ))}
        </Box>
      </>
    </Container>
  )
}
